<template>
  <button
    type="button"
    class="theme-toggle"
    :title="isDark ? 'Switch to light mode' : 'Switch to dark mode'"
    :aria-label="isDark ? 'Switch to light mode' : 'Switch to dark mode'"
    @click="onToggle"
  >
    <span aria-hidden="true">{{ isDark ? '☀' : '☾' }}</span>
  </button>
</template>

<script>
import { initTheme, resolveTheme, toggleTheme } from '@/lib/theme';

export default {
  name: 'ThemeToggle',
  data() {
    return {
      isDark: false
    };
  },
  created() {
    this.isDark = initTheme() === 'dark';
  },
  methods: {
    onToggle() {
      this.isDark = toggleTheme() === 'dark';
      this.$emit('change', this.isDark ? 'dark' : 'light');
    },
    refresh() {
      this.isDark = resolveTheme() === 'dark';
    }
  }
};
</script>

<style lang="scss" scoped>
.theme-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.25rem;
  height: 2.25rem;
  border-radius: 999px;
  border: 1px solid var(--line);
  background: transparent;
  color: var(--ink);
  cursor: pointer;
  font-size: 1rem;
  line-height: 1;
  box-shadow: none;
  transition: border-color 0.15s, color 0.15s;

  &:hover {
    border-color: var(--ink);
  }
}

html[data-theme="dark"] .theme-toggle {
  background: transparent;
  border-color: var(--line);
  color: var(--ink);
}
</style>
